import React, { Component } from "react";
import approveIcon from "../../../assets/ministry_approve_icon.svg";
import { ConfirmationComponent } from "../../ConfirmationComponent";
import {
  approveComment,
  issueActivityCommentParams
} from "../../../services/apiServices";
import request from "../../../services/requestService";
import { LoaderPage } from "../../../component/Loader";
import { toast } from "react-toastify";
import { errorToastStyle, successToastStyle } from "../../../customToast";
export default class Approve extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCommentPopUp: false,
      isLoading: false
    };
  }
  toggleApprovePopUp = () => {
    this.setState(prevState => ({
      showCommentPopUp: !prevState.showCommentPopUp
    }));
  };
  approveComment = async () => {
    const { commentId, getAllComments } = this.props;

    const payload = {
      commentId: commentId,
      modifiedComment: ""
    };

    try {
      this.setState(prevState => ({
        showCommentPopUp: !prevState.showCommentPopUp,
        isLoading: true
      }));

      const response = await request(approveComment(payload));

      if (response.data.status) {
        toast.success(
          <p className="toast-text-alignment">{response.data.message}</p>,
          successToastStyle
        );
        getAllComments("comment");
      } else {
        toast.error(
          <p className="toast-text-alignment">{response.data.message}</p>,
          errorToastStyle
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      // ✅ Stop loader immediately after API completes
      this.setState({ isLoading: false });
    }
  };
  render() {
    const { showCommentPopUp, isLoading } = this.state;
    return (
      <>
        <LoaderPage loading={isLoading} />
        {showCommentPopUp ? (
          <ConfirmationComponent
            show={showCommentPopUp}
            isLoading={false}
            modalClass={"confirmation-modal notification-delete"}
            saveHandler={this.approveComment}
            closeHandler={this.toggleApprovePopUp}
            content={"Are you sure you want to approve?"}
          />
        ) : null}
        {/* <button className="ministry-btn-approve"  onClick={this.toggleApprovePopUp}>
    <img src={approveIcon} alt="approve" className="ministry-btn-icon" />
    Approve
  </button> */}
        <img
          src={approveIcon}
          alt="approve"
          className="ministry-btn-icon"
          onClick={this.toggleApprovePopUp}
        />
      </>
    );
  }
}
